import type { PlatformThemeColors } from './types';

/** Solid PWA chrome tokens (header / tab bar / under-bar). Never glass rgba. */
export function getShellChromeVars(
  colors: PlatformThemeColors,
  textMuted: string,
): Record<string, string> {
  const chromeBg = colors.headerBackground || colors.surface;
  return {
    '--shell-chrome-bg': chromeBg,
    '--shell-chrome-border': colors.border,
    '--shell-chrome-fg': textMuted,
    '--shell-chrome-fg-active': colors.accentPrimary,
  };
}
